/** Zonas horarias comunes en América Latina y España, para navegadores viejos. */
const FALLBACK_TIMEZONES = [
  'America/Argentina/Buenos_Aires',
  'America/Mexico_City',
  'America/Bogota',
  'America/Santiago',
  'America/Lima',
  'America/Montevideo',
  'America/Caracas',
  'America/La_Paz',
  'America/Guatemala',
  'America/Havana',
  'America/Santo_Domingo',
  'America/New_York',
  'Europe/Madrid',
  'UTC',
];

/**
 * Zonas horarias disponibles para elegir en el registro.
 *
 * `Intl.supportedValuesOf` no existe en todos los navegadores; sin ella se usa
 * una lista corta con las zonas más comunes para quienes usan el sitio, para
 * que el formulario siga siendo utilizable.
 */
export function availableTimeZones(): string[] {
  try {
    return Intl.supportedValuesOf('timeZone');
  } catch {
    return FALLBACK_TIMEZONES;
  }
}

/** Desplazamiento UTC actual de una zona horaria, para mostrar junto al nombre. */
export function timeZoneOffsetLabel(timeZone: string): string {
  try {
    const parts = new Intl.DateTimeFormat('es', {
      timeZone,
      timeZoneName: 'shortOffset',
    }).formatToParts(new Date());
    const offset = parts.find((part) => part.type === 'timeZoneName')?.value;
    return offset ?? '';
  } catch {
    return '';
  }
}
